import React from "react"
import autobind from "class-autobind"
import { Toggle, Card, CardHeader, CardText } from "material-ui"
import strings from "../../localization/strings"
import AppStateStore from "../../stores/AppStateStore"
import * as  accountActions from "../../actions/AccountActions"
import { IHierarchyItem, IHierarchyItemSettings, IHierarchyItemForAccountLevel, IJobDocument } from "../../models"
import * as hierarchyHelper from "../../helpers/hierarchyHelper"
import AccountStore from "../../stores/AccountStore"
import _ from "lodash"
import HierarchyJobVariations from "./hierarchy_job_variations/HierarchyJobVariations"

interface IProps {
    hierarchyJobItem: IHierarchyItem | IHierarchyItemForAccountLevel | IJobDocument
    inheritedHierarchyJobItem: IHierarchyItem | IJobDocument
    readonly: boolean
    handleUpdateJob(job: IJobDocument): Promise<void>
}
interface IState {
    expand: boolean
    isRoot: boolean
    canOverride: boolean
    autoTransfer: boolean
}

export default class HierarchySettingsAutoTransfer extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            expand: false,
            isRoot: true,
            canOverride: false,
            autoTransfer: false
        }
        autobind(this)
    }

    componentDidMount() {
        this.checkIsRoot(this.props.hierarchyJobItem)
        this.getAutoTransferSetting(this.props.inheritedHierarchyJobItem)
    }

    componentWillReceiveProps(nextProps: IProps) {
        !_.isEqual(this.props.hierarchyJobItem, nextProps.hierarchyJobItem) &&
            this.checkIsRoot(nextProps.hierarchyJobItem)
        !_.isEqual(this.props.inheritedHierarchyJobItem, nextProps.inheritedHierarchyJobItem) &&
            this.getAutoTransferSetting(nextProps.inheritedHierarchyJobItem)
    }

    checkIsRoot(hierarchyJobItem: IHierarchyItemForAccountLevel | IHierarchyItem | IJobDocument) {
        hierarchyJobItem = hierarchyJobItem as IHierarchyItemForAccountLevel
        this.setState({ isRoot: hierarchyJobItem && hierarchyJobItem.level && hierarchyJobItem.level === -1 ? true : false }, () =>
            this.getCanOverride()
        )
    }

    getCanOverride() {
        if (!this.state.isRoot) {
            const hierarchyJobItem = this.props.hierarchyJobItem as (IHierarchyItem | IJobDocument)
            const inheritedHierarchyJobItemId = this.props.inheritedHierarchyJobItem ? this.props.inheritedHierarchyJobItem.Id : null
            this.setState({ canOverride: hierarchyJobItem.Id === inheritedHierarchyJobItemId })
        }
        else {
            this.setState({ canOverride: false })
        }
    }

    getAutoTransferSetting(inheritedHierarchyJobItem: (IHierarchyItem | IJobDocument)) {
        const hierarchySettings = inheritedHierarchyJobItem ?
            inheritedHierarchyJobItem.HierarchyItemSettings :
            AccountStore.getCurrentAccount().HierarchyItemSettings
        this.setState({ autoTransfer: hierarchySettings.AutoTransferSettings ? hierarchySettings.AutoTransferSettings.AutoTransferPunchOut : false })
    }

    handleSave(canOverride, autoTransfer: boolean) {
        AppStateStore.setProgressSnackbarContent("loading")
        setTimeout(() => {
            this.setState({ canOverride, autoTransfer }, () =>
                this.state.isRoot ?
                    this.updateAccountAutoTransferSetting() :
                    this.updateHierarchyJobItemAutoTransferSetting()
            )
        }, 1000)
    }

    updateAccountAutoTransferSetting() {
        let hierarchyItemSettings = AccountStore.getCurrentAccount().HierarchyItemSettings
        if (hierarchyItemSettings) {
            hierarchyItemSettings.AutoTransferSettings = { AutoTransferPunchOut: this.state.autoTransfer }
        } else {
            hierarchyItemSettings = { AutoTransferSettings: { AutoTransferPunchOut: this.state.autoTransfer } } as IHierarchyItemSettings
        }
        accountActions.patchAccountHierarchySettings(AccountStore.getCurrentAccount().Id, { HierarchyItemSettings: hierarchyItemSettings })
    }

    updateHierarchyJobItemAutoTransferSetting() {
        const hierarchyJobItem = this.props.hierarchyJobItem as (IHierarchyItem | IJobDocument)
        if (this.state.canOverride) {
            if (hierarchyJobItem.HierarchyItemSettings) {
                hierarchyJobItem.HierarchyItemSettings.AutoTransferSettings = { AutoTransferPunchOut: this.state.autoTransfer }
            } else {
                hierarchyJobItem.HierarchyItemSettings = { AutoTransferSettings: { AutoTransferPunchOut: this.state.autoTransfer } } as IHierarchyItemSettings
            }
        } else {
            if (hierarchyJobItem.HierarchyItemSettings) {
                hierarchyJobItem.HierarchyItemSettings.AutoTransferSettings = null
            } else {
                hierarchyJobItem.HierarchyItemSettings = { AutoTransferSettings: null } as IHierarchyItemSettings
            }
        }
        hierarchyJobItem.hasOwnProperty("AccountId") ?
            this.props.handleUpdateJob(hierarchyJobItem as IJobDocument).then(() => AppStateStore.setProgressSnackbarContent(null)) :
            accountActions.updateAccountHierarchyItem(AccountStore.getCurrentAccount().Id, hierarchyJobItem, true)
    }

    render() {
        return (
            <div className="HierarchySettingsAutoTransfer">
                <Card
                    data-intercom-target={"menu-Hierarchy-Settings-AutoTransfer"}
                    expanded={this.state.expand}
                    onExpandChange={expand => this.setState({ expand })}
                >
                    <CardHeader
                        title={strings.AutoTransfer}
                        subtitle={[
                            <span key="title">
                                {this.state.isRoot ?
                                    `(${strings.not_inherited})` :
                                    !this.props.inheritedHierarchyJobItem ?
                                        `(${strings.formatString(strings.inherited_from_Account_x, AccountStore.getCurrentAccount().Name)})` :
                                        this.props.inheritedHierarchyJobItem.Id === (this.props.hierarchyJobItem as (IHierarchyItem | IJobDocument)).Id ?
                                            `(${strings.not_inherited})` :
                                            `(${strings.formatString(strings.inherited_from_x, `${hierarchyHelper.getHierarchyDefinitionByHierarchyItemId(this.props.inheritedHierarchyJobItem.Id).Label}:  ${(this.props.inheritedHierarchyJobItem as IHierarchyItem).Label}`)})`
                                }
                            </span>,
                            this.state.expand &&
                            <HierarchyJobVariations
                                key="hierarchy job variations"
                                settingPropertyName="AutoTransferSettings"
                                hierarchyJobItem={this.props.hierarchyJobItem}
                                inheritedHierarchyJobItem={this.props.inheritedHierarchyJobItem}
                            />
                        ]}
                        actAsExpander={true}
                        showExpandableButton={true}
                        titleStyle={{
                            fontSize: 20,
                            fontWeight: 500,
                            display: "initial"
                        }}
                        subtitleStyle={{
                            fontSize: 13,
                            color: "rgb(97, 97, 97)",
                            marginLeft: 10,
                            display: "initial"
                        }}
                    />
                    <CardText expandable={true}>
                        <div style={styles.body}>
                            {!this.state.isRoot &&
                                <Toggle
                                    data-intercom-target={"menu-Hierarchy-Settings-AutoTransfer-Toggle-Override"}
                                    label={strings.Override}
                                    style={styles.toggle}
                                    toggled={this.state.canOverride}
                                    disabled={this.props.readonly}
                                    onToggle={(event, canOverride) =>
                                        AppStateStore.setConfirmDialogContent({
                                            content: strings.Are_you_sure_you_want_to_change_this_setting_of_hierarchy,
                                            confirm: () => canOverride ?
                                                this.setState({ canOverride }, () => this.updateHierarchyJobItemAutoTransferSetting()) :
                                                this.handleSave(canOverride, this.state.autoTransfer)
                                        })
                                    }
                                />
                            }
                            {(this.state.isRoot || this.state.canOverride) && !this.props.readonly ?
                                <Toggle
                                    data-intercom-target={"menu-Hierarchy-Settings-AutoTransfer-Toggle-EnableAutoTransfer"}
                                    label={strings.Enable_Auto_Transfer}
                                    style={styles.toggle}
                                    onToggle={(event, value) =>
                                        AppStateStore.setConfirmDialogContent({
                                            content: strings.Are_you_sure_you_want_to_change_this_setting_of_hierarchy,
                                            confirm: () => this.handleSave(this.state.canOverride, value)
                                        })
                                    }
                                    toggled={this.state.autoTransfer}
                                /> :
                                <div style={{ marginBottom: 22, marginTop: 22 }}>
                                    <span>{strings.Enable_Auto_Transfer}</span>
                                    <span style={{ marginLeft: 130 }}>{this.state.autoTransfer ? "True" : "False"}</span>
                                </div>
                            }
                        </div>
                    </CardText>
                </Card>
            </div>
        )
    }
}

const styles = {
    toggle: {
        marginBottom: 20
    },
    body: {
        maxWidth: 300
    },
    titleExpandOn: {
        marginBottom: 30
    },
    titleExpandOff: {
        marginBottom: 0
    }
}